// extracted by mini-css-extract-plugin
export default {"container":"CadaVezMas_container__USD2p","info":"CadaVezMas_info__EouxF","infoText":"CadaVezMas_infoText__qWmK-","containerLogos":"CadaVezMas_containerLogos__gTxRq"};